import { useCallback } from "react";
import { db } from "../Firebase/firebase-config";
import { ref, push, set } from "firebase/database";

export const useNotifications = () => {
  const sendNotification = useCallback(async ({
    targetUserId,
    title,
    message,
    pageTitle = "Notification",
    category = "general",
    gifUrl = "/Images/New notification.gif",
    isSupplier = false,
    data = {},
  }) => {
    if (!targetUserId) {
      console.warn("Notification: targetUserId is required");
      return;
    }

    try {
      const notificationsRef = ref(db, `transport_notifications/${targetUserId}`);
      const newNotifRef = push(notificationsRef);

      const notificationData = {
        id: newNotifRef.key,
        title,
        message,
        pageTitle,
        category,
         gifUrl,
        isSupplier,
        data,
        timestamp: Date.now(),
        read: false,
        createdAt: Date.now(),
      };

      await set(newNotifRef, notificationData);

      // Optional: Update unread count
      const unreadRef = ref(db, `transport_notifications/${targetUserId}/unreadCount`);
      // You can increment this using a transaction if needed
      return newNotifRef.key;
    } catch (error) {
      console.error("Failed to send notification:", error);
    }
  }, []);

  return { sendNotification };
};